import Assign from './Assign'

export default {
  name: 'Assign',
  component: Assign
}
